// extracted by mini-css-extract-plugin
export default {"SideBar":"SideBar_SideBar__KP3Jy","inNavbar":"SideBar_inNavbar__k0b3j"};